import { createFileRoute } from "@tanstack/react-router";
import { CampanasPanel } from "@/components/admin/CampanasPanel";
import { paginationValidator } from "@/hooks/use-table-pagination";

export const Route = createFileRoute("/admin/campanas")({
  validateSearch: paginationValidator,
  component: CampanasPanel,
});
